import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJump: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconJump"><Path d="M22 11H20V7.30859C16.4443 10.6235 13.8611 13.8886 13.1426 18H17V20H7V18H10.9561C10.7252 15.4427 9.54459 13.06 7.83594 11.2529C5.91964 9.22621 3.41857 8 1 8V6C4.08141 6 7.08036 7.54295 9.28906 9.87891C10.4924 11.1516 11.4804 12.6838 12.1348 14.374C13.4604 11.2069 15.7726 8.53541 18.4727 6H15V4H22V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconJump;
